import React, {Fragment} from 'react';

class AppFooter extends React.Component {
    render() {


        return (
            <Fragment>
                <div className="app-footer">
                    <div className="app-footer__inner">
                        <div className="app-footer-left">
                            <ul className="nav">
                                <li className="nav-item">
                                    <a target="_blank" href="http://lectoresgalacticos.leer.org.ar/ " className="nav-link">
                                        Ver Juego
                                    </a>
                                </li>
                                
                            </ul>
                        </div>
                        
                    </div>
                </div>
            </Fragment>
        )}
}

export default AppFooter;


// WEBPACK FOOTER //
// src/Layout/AppFooter/index.js